export default {
  "name": "Name",
  "save": "Save",
  "saveAs": "Save as",
  "back": "Back",
  "loading": "Loading...",
  "resetOperations": "Reset/delete all operations",
  "changesLoseConfirmation": "All changes will be lost",
  "changesLoseConfirmationHint": "Are you sure you want to continue?",
  "cancel": "Cancel",
  "continue": "Continue",
  "undoTitle": "Undo last operation",
  "redoTitle": "Redo last operation",
  "showImageTitle": "Show original image",
  "zoomInTitle": "Zoom in",
  "zoomOutTitle": "Zoom out",
  "fitToScreenTitle": "Fit to screen",
  "toggleZoomMenuTitle": "Toggle zoom menu",
  "adjustTab": "Adjust",
  "templateTab": "Templates",
  "backgroundTab": "Background",
  "finetuneTab": "Finetune",
  "filtersTab": "Effects",
  "watermarkTab": "Watermark",
  "annotateTab": "Draw",
  "imageGalleryTab": "Image",
  "layersModeTitle": "Toggle layers panel",
  "layersModeShort": "Layers",
  "layersPanelTitle": "Layers",
  "layersPanelClose": "Close layers panel",
  "layersPanelEmpty": "No layers on the canvas yet.",
  "layersPanelDragHint": "Drag to reorder",
  "layersPanelDragDisabledLocked": "Unlock the layer to reorder",
  "layersPanelHideLayer": "Hide layer",
  "layersPanelShowLayer": "Show layer",
  "layersPanelDeleteLayer": "Remove layer",
  "layersPanelDeleteDisabledLocked": "Unlock the layer to remove",
  "layersPanelLocked": "Locked",
  "layersPanelWatermark": "Watermark",
  "layersPanelTypeText": "Text",
  "layersPanelTypeImage": "Image",
  "layersPanelTypeRect": "Rectangle",
  "layersPanelTypeEllipse": "Ellipse",
  "layersPanelTypePolygon": "Polygon",
  "layersPanelTypeStar": "Star",
  "layersPanelTypeLine": "Line",
  "layersPanelTypeArrow": "Arrow",
  "layersPanelTypePen": "Pen",
  "layersPanelTypeLayer": "Layer",
  "resize": "Resize",
  "resizeTab": "Resize",
  "invalidImageError": "Invalid image provided.",
  "uploadImageError": "Error while uploading the image.",
  "uploadImageFromComputer": "Upload image",
  "uploadImageImporting": "Importing...",
  "areNotImages": "are not images",
  "isNotImage": "is not image",
  "toBeUploaded": "to be uploaded",
  "cropTool": "Crop",
  "original": "Original",
  "custom": "Custom",
  "square": "Square",
  "landscape": "Landscape",
  "portrait": "Portrait",
  "ellipse": "Ellipse",
  "classicTv": "Classic TV",
  "cinemascope": "Cinemascope",
  "arrowTool": "Arrow",
  "blurTool": "Blur",
  "brightnessTool": "Brightness",
  "contrastTool": "Contrast",
  "ellipseTool": "Ellipse",
  "flipX": "Flip background X",
  "unFlipX": "Un-flip background X",
  "flipY": "Flip background Y",
  "unFlipY": "Un-flip background Y",
  "hsvTool": "HSV",
  "hue": "Hue",
  "saturation": "Saturation",
  "value": "Value",
  "imageTool": "Image",
  "importing": "Importing...",
  "addImage": "+ Icons",
  "lineTool": "Line",
  "penTool": "Pen",
  "polygonTool": "Polygon",
  "starTool": "Star",
  "sides": "Sides",
  "rectangleTool": "Rectangle",
  "cornerRadius": "Corner Radius",
  "resizeWidthTitle": "Width in pixels",
  "resizeHeightTitle": "Height in pixels",
  "toggleRatioLockTitle": "Toggle ratio lock",
  "reset": "Reset",
  "annotationOptionClose": "Close",
  "resetSize": "Reset to original image size",
  "rotateTool": "Rotate",
  "textTool": "Text",
  "textStyles": "Text styles",
  "textStylesTitle": "Browse text style templates",
  "textStylesShort": "Text styles",
  "editWording": "Edit wording",
  "drawInspectorTextLabel": "Wording",
  "drawInspectorTextPlaceholder": "Type or paste your text…",
  "drawInspectorTextHint": "Canvas updates as you type. Enter adds a line and resizes the box. Escape reverts.",
  "fillColor": "Color",
  "fontBold": "Bold",
  "fontItalic": "Italic",
  "lockShort": "Lock",
  "unlockShort": "Unlock",
  "groupShort": "Group",
  "ungroupShort": "Ungroup",
  "textSpacings": "Text spacings",
  "textAlignment": "Text alignment",
  "textAlignmentShort": "Align",
  "textSpacingsShort": "Spacing",
  "letterSpacingShort": "Spacing",
  "lineHeightShort": "Line height",
  "fitTextToContentTitle": "Fit box to text",
  "fitTextToContentShort": "Fit",
  "textAutoHugTitle": "Auto-fit text box while editing",
  "textAutoHugShort": "Auto-fit",
  "alignCanvasTitle": "Align to canvas",
  "alignCanvasCenterHorizontalTitle": "Center selection on canvas (horizontal)",
  "alignCanvasCenterHorizontalShort": "Center H",
  "alignCanvasCenterVerticalTitle": "Center selection on canvas (vertical)",
  "alignCanvasCenterVerticalShort": "Center V",
  "replaceImageTitle": "Replace image (keeps size and position)",
  "replaceImageShort": "Replace",
  "snapToGuidesTitle": "Snap to alignment guides while dragging",
  "snapToGuidesShort": "Snap",
  "smartGuidesShort": "Smart Guides",
  "themeToggleTitle": "Switch light or dark theme",
  "themeLight": "Light theme",
  "themeDark": "Dark theme",
  "propertiesAndTools": "Properties & Tools",
  "canvasModeToolbarTitle": "Canvas interaction",
  "canvasModeSelect": "Select",
  "canvasModeSelectTitle": "Select and move layers on the canvas",
  "canvasModePan": "Pan",
  "canvasModePanTitle":
    "Pan the canvas — drag anywhere to move the view (scroll wheel still zooms)",
  "canvasModePanTitleZoomIn":
    "Pan — zoom in to at least 110% first (scroll wheel or + in the top bar)",
  "fontFamily": "Font family",
  "size": "Size",
  "decreaseFontSize": "Decrease font size",
  "increaseFontSize": "Increase font size",
  "letterSpacing": "Letter spacing",
  "lineHeight": "Line height",
  "alignLeft": "Align left",
  "alignCenter": "Align center",
  "alignRight": "Align right",
  "warmthTool": "Warmth",
  "addWatermark": "+ Add",
  "addWatermarkTitle": "Choose the watermark type",
  "uploadWatermark": "Upload watermark",
  "addWatermarkAsText": "Add as text",
  "padding": "Padding",
  "shadow": "Shadow",
  "horizontal": "Horizontal",
  "vertical": "Vertical",
  "blur": "Blur",
  "color": "Color",
  "opacity": "Opacity",
  "position": "Position",
  "stroke": "Stroke",
  "saveAsModalLabel": "Save the image as",
  "extension": "Extension",
  "nameIsRequired": "Name is required.",
  "quality": "Quality",
  "imageDimensionsHoverTitle": "Saved image size (width x height)",
  "cropSizeLowerThanResizedWarning": "Note, the selected crop area is lower than the applied resize which might cause quality decrease",
  "actualSize": "Actual size (100%)",
  "fitSize": "Fit size",
  "socialMedia": "Social media",
  "addBackgroundAsText": "Add as text",
  "imageTypeWillChangeOnSave": "On saving you will choose a new image type/extension to save with",
  "storyPhoto": "Story photo",
  "twInStreamPhotoSize": "1600x1900px",
  "closeEditor": "Close editor",
  "resetZoomTitle": "Zoom percentage (Click to reset)",
  "headerPhoto": "Header photo",
  "feedSquarePhoto": "Feed square photo",
  "twHeaderPhotoSize": "1500x500px",
  "igStoryPhotoSize": "1080x1920px",
  "igProfilePhoto": "320x320px",
  "fbStoryPhotoSize": "1080x1920px",
  "igFeedSquarePhotoSize": "1080x1080px",
  "instagram": "Instagram",
  "addBackground": "+ Add background",
  "previewTool": "Preview",
  "liProfilePhotoSize": "400x400px",
  "liProfileCoverPhotoSize": "1584x396px",
  "inStreamPhoto": "In-stream photo",
  "twProfilePhotoSize": "400x400px",
  "annotationVariable": "Set annotation variable",
  "linkedIn": "LinkedIn",
  "blurRadius": "blurRadius",
  "imageTypeNotSavingSupported": "Image type/extension is NOT supported on saving",
  "addBackgroundTitle": "Choose the background type",
  "profileCoverPhoto": "Profile cover photo",
  "feedPortraitPhoto": "Feed portrait photo",
  "twitter": "Twitter",
  "liCompanyLogoSize": "300x300px",
  "backgroundTab": "Background",
  "igProfilePhotoSize": "320x320px",
  "liBlogPostPhotoSize": "1200x627px",
  "measureTool": "Measure",
  "timelinePhoto": "Timeline photo",
  "eventCoverPhoto": "Event cover photo",
  "facebook": "Facebook",
  "fbEventCoverPhotoSize": "1200x628px",
  "companyPageCover": "Company page cover",
  "blogPostPhoto": "Blog post photo",
  "download": "Download",
  "saveDownloadPngTransparentHint": "Without background image",
  "saveDownloadPdfHint": "Print-ready single page",
  "bannerFrameSizeTitle": "Frame size",
  "bannerFrameCustomSize": "Custom size",
  "bannerFrameApplyCustom": "Apply",
  "bannerFrameMarketingPresets": "Marketing presets",
  "width": "Width",
  "height": "Height",
  "bannerFrameGroupInstagram": "Instagram",
  "bannerFrameGroupFacebook": "Facebook",
  "bannerFrameGroupWhatsapp": "WhatsApp",
  "bannerFrameGroupVideo": "Video",
  "bannerFrameGroupLinkedin": "LinkedIn",
  "bannerFrameGroupTwitter": "X",
  "bannerFrameGroupPinterest": "Pinterest",
  "bannerFrameGroupOther": "Other",
  "bannerFrameInstagramPost": "Instagram post",
  "bannerFrameInstagramStory": "Instagram story",
  "bannerFrameInstagramPortrait": "Instagram portrait (4:5)",
  "bannerFrameFacebookPost": "Facebook post",
  "bannerFrameFacebookCover": "Facebook cover",
  "bannerFrameWhatsappStatus": "WhatsApp status",
  "bannerFrameYoutubeThumbnail": "YouTube thumbnail",
  "bannerFrameTiktokVideo": "TikTok video",
  "bannerFrameLinkedinPost": "LinkedIn post",
  "bannerFrameTwitterPost": "X post",
  "bannerFramePinterestPin": "Pinterest pin",
  "bannerFrameInstagramPostShort": "Post",
  "bannerFrameInstagramStoryShort": "Story",
  "bannerFrameInstagramPortraitShort": "Portrait",
  "bannerFrameFacebookPostShort": "Post",
  "bannerFrameFacebookCoverShort": "Cover",
  "bannerFrameWhatsappStatusShort": "Status",
  "bannerFrameYoutubeThumbnailShort": "Thumbnail",
  "bannerFrameTiktokVideoShort": "Video",
  "bannerFrameLinkedinPostShort": "Post",
  "bannerFrameTwitterPostShort": "Post",
  "bannerFramePinterestPinShort": "Pin",
  "fbProfilePhotoSize": "170x170px",
  "srTab": "SR",
  "uploadBackground": "Upload background",
  "downloadAsModalLabel": "Save the image as",
  "circle": "Circle",
  "addByUrl": "+ Add URL",
  "feedLandscapePhoto": "Feed landscape photo",
  "igFeedLandscapePhotoSize": "1080x566px",
  "cancelEditing": "Cancel editing",
  "liCompanyPageCoverSize": "1128x191px",
  "transparency": "Opacity",
  "profilePhoto": "Profile photo",
  "igFeedPortraitPhotoSize": "1080x1350px",
  "fbProfileCoverPhotoSize": "851x315px",
  "fbTimelinePhotoSize": "1200x630px",
  "companyLogo": "Company logo",
  "layerOrderTitle": "Layer order",
  "layerOrderDisabledSingleLayer": "Only one layer on the canvas",
  "layerOrderDisabledNoSelection": "Select a layer first",
  "layerOrderDisabledAtLimit": "Already at this layer limit",
  "layerOrderDisabledLocked": "Unlock the layer to change stack order",
  "bringForwardTitle": "Bring forward (Ctrl+])",
  "sendBackwardTitle": "Send backward (Ctrl+[)",
  "bringToFrontTitle": "Bring to front (Ctrl+Shift+])",
  "sendToBackTitle": "Send to back (Ctrl+Shift+[)",
  "bringForwardShort": "Forward",
  "sendBackwardShort": "Backward",
  "bringToFrontShort": "To front",
  "sendToBackShort": "To back",
  "duplicateSelectionTitle": "Duplicate (Ctrl+D)",
  "deleteSelectionTitle": "Delete (Backspace)",
  "multiLayoutTitle": "Align and distribute selection",
  "multiAlignTitle": "Align selection",
  "multiAlignLeftTitle": "Align left",
  "multiAlignLeftShort": "Left",
  "multiAlignCenterTitle": "Align center",
  "multiAlignCenterShort": "Center",
  "multiAlignRightTitle": "Align right",
  "multiAlignRightShort": "Right",
  "multiAlignTopTitle": "Align top",
  "multiAlignTopShort": "Top",
  "multiAlignMiddleTitle": "Align middle",
  "multiAlignMiddleShort": "Middle",
  "multiAlignBottomTitle": "Align bottom",
  "multiAlignBottomShort": "Bottom",
  "multiDistributeHorizontalTitle": "Distribute horizontally",
  "multiDistributeHorizontalShort": "Dist H",
  "multiDistributeVerticalTitle": "Distribute vertically",
  "multiDistributeVerticalShort": "Dist V",
  "multiAlignDisabledNeedTwo": "Select at least two layers",
  "multiDistributeDisabledNeedThree": "Select at least three layers",
  "groupLockTitle": "Group and lock",
  "groupSelectionTitle": "Group selection",
  "ungroupSelectionTitle": "Ungroup selection",
  "lockSelectionTitle": "Lock selection",
  "unlockSelectionTitle": "Unlock selection",
  "groupSelectionDisabled": "Select at least two layers",
  "ungroupSelectionDisabled": "Selection is not grouped",
  "lockSelectionDisabled": "All selected layers are locked",
  "unlockSelectionDisabled": "No locked layers in selection"
}